export const ItemSkeleton = () => {
  return (
    <div
      role="listitem"
      aria-label="Loading"
      className="grid cursor-pointer grid-cols-[40px_auto] items-start gap-x1_5 rounded-md p-x1"
    >
      <div className="size-10 rounded-md bg-surface-3" />
      <div className="grid items-center">
        <div className="h-3 w-24 rounded-sm bg-surface-3" />
        <div className="mt-x0_5 space-y-x0_5">
          <div className="h-3 w-full rounded-sm bg-surface-3" />
          <div className="flex items-center gap-x0_75">
            <div className="h-3 w-16 rounded-sm bg-surface-3" />
          </div>
        </div>
      </div>
    </div>
  );
};
